module.exports = __webpack_public_path__ + "static/img/newPrice_2.489b25a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newPrice_2.jpg
// module id = mNma
// module chunks = 1